import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../../services/subscription/subscription.service';
import { SpinnerService } from '../../services/sppiner/spinner.service';
import { SectionBannerComponent } from '../../shared/section-banner/section-banner.component';
import { CommonModule } from '@angular/common';
import { ImageConverterPipe } from '../../pipes/image-converter.pipe';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-unsubscribe',
  standalone: true,
  imports: [SectionBannerComponent, CommonModule, ImageConverterPipe, RouterModule, TranslateModule],
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.scss',
})
export class UnsubscribeComponent {
  isUnsubscribed: boolean = false;
  errorMessage: string | null = null;
  email: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private subscriptionService: SubscriptionService,
    public spinnerService: SpinnerService,
    private translate: TranslateService
  ) {
    this.email = this.route.snapshot.queryParamMap.get('email');
  }

  ngAfterViewInit(): void {
    window.scrollTo({ top: 0 });

    setTimeout(() => {
      const element = document.getElementById('unsubscribe-anchor');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  unsubscribe() {
    this.spinnerService.show();
    this.errorMessage = null;

    if (!this.email) {
      this.errorMessage = this.translate.instant('unsubscribe.error_invalid_email');
      this.spinnerService.hide();
      return;
    }

    this.subscriptionService.unsubscribeUser(this.email).subscribe({
      next: () => {
        this.isUnsubscribed = true;
        setTimeout(() => this.router.navigate(['/']), 10000);
      },
      error: () => {
        this.errorMessage = this.translate.instant('unsubscribe.error_generic');
        setTimeout(() => {
          this.spinnerService.hide();
        }, 1000);
      },
      complete: () => {
        this.spinnerService.hide();
      }
    });
  }

  goHome() {
    this.router.navigate(['/']);
  }

  contactSupport() {
    this.router.navigate(['/contact']);
  }
}
